// src/utils/history.js

const HISTORY_KEY = "chafadi-recently-viewed";
const MAX_HISTORY_LENGTH = 5; // Show the last 5 items

export const getRecentlyViewed = () => {
  const history = localStorage.getItem(HISTORY_KEY);
  return history ? JSON.parse(history) : [];
};

export const addRecentlyViewed = (product) => {
  if (!product || !product.id) return;

  let history = getRecentlyViewed();
  // Remove the item if it already exists to move it to the front
  history = history.filter((item) => item.id !== product.id);

  // Add the new product to the beginning of the array
  history.unshift(product);

  // Trim the array to the max length
  if (history.length > MAX_HISTORY_LENGTH) {
    history = history.slice(0, MAX_HISTORY_LENGTH);
  }

  localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
  console.log("✅ Updated recently viewed items.");
};
